<template>
  <div class="dialog-bg dark-bg">
    <div class="scanner-intro">
      <h3>Scan Code</h3>
      <p>วิธีใช้หันกล้องให้ตำแหน่ง Barcode อยู่บริเวณตรงกลางหน้าจอ</p>
    </div>
    <div class="scanner-wrapper">
      <div id="interactive" class="viewport">
        <video id="barcode-reader" width="640" height="360"></video>
      </div>
      <pre class="output">{{ output }}</pre>
    </div>
    <div v-if="controls" class="controls">
      <button @click="init">Start</button>
      <button @click="destroy">Stop</button>
    </div>
    <div class="scanner-close" @click="close">
      <span>ย้อนกลับ</span>
    </div>
  </div>
</template>

<script>
import "webrtc-adapter";
import { BrowserBarcodeReader } from "@zxing/library";

export default {
  props: {
    controls: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      reader: new BrowserBarcodeReader(2500),
      output: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    close() {
      this.output = "";
      this.destroy();
      this.$emit("close");
    },
    destroy() {
      if (this.reader) {
        this.reader.reset();
      }
    },
    async init() {
      const {reader} = this;

      try {
        const devices = await reader.listVideoInputDevices();
        if (devices.length > 0) {
          this.output = `Using ${devices[0].label}`;
          const {deviceId} = devices[0];

          const output = await reader.decodeOnceFromVideoDevice(
            deviceId,
            "barcode-reader"
          );

          this.$emit("detect", output.getText());
          this.close();
        }
      } catch (err) {
        this.output = `Problems - ${err}`;
      }
    }
  }
};
</script>

<style lang="scss">
.controls {
  position: absolute;
  width: 100%;
  text-align: center;
  bottom: 2%;
  left: 0;
  right: 0;
}
.scanner {
  &-close {
    position: absolute;
    color: #e0e0e0;
    border: 1px solid;
    border-radius: 15px;
    padding: 10px 30px;
    top: 4%;
    left: 4%;
    cursor: pointer;
  }
  &-intro {
    color: $white;
    margin-top: 4%;
    text-align: center;

    p {
      color: darken($white, 20%);
      text-align: center;
    }
  }
  &-wrapper {
    padding: 10px;
    position: absolute;
    background-color: transparent;
    border: 2px dashed #ff9a00;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 664px;

    #interactive {
      width: 640px;
      height: 360px;
      position: relative;
      background: $green;

      &.viewport {
        position: relative;

        > video {
          max-width: 100%;
          width: 100%;
          height: 100%;
        }
      }

      .drawingBuffer {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
}
.dark-bg {
  background-color: $black;
}
.output {
  font-size: 12px;
  color: #aaa;
  margin: 0;
}
</style>
